/*
 * @Author: zloongjiang
 * @Date:   2019-09-04 15:40:06
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-04-27 20:47:26
 */

// flow
import isArray from 'lodash/isArray';
import get from 'lodash/get';
import * as React from 'react';
import { isQbInfoApp } from '../UA';

export function paramTruly(value) {
  return Boolean(value && value !== '0' && value !== 'false' && value !== 'undefined');
}

export const isQehId = (id: string = '') => /^qeh_/.test(id); // 判断是否是企鹅号
export const isQbKdId = (id: string = '') => /^qbKd_/.test(id); // 判断是否是看点号
export const isPuinId = (id: string = '') => /^puin_/.test(id); // 判断是否是看点号
export const isValidId = (id: string = '') => isQehId(id) || isQbKdId(id) || isPuinId(id);
export const getIdType = (id: string = '') => {
  let type = -1;
  [isQehId, isQbKdId, isPuinId].forEach((checker, index) => {
    if (checker(id)) {
      type = [9, 14, 15][index];
    }
  });
  return type;
};
export const redirect = (url: string) => {
  window.location.href = url;
};

export const getStyleByArrayData = (styles: Array<Object>, highLevel?: boolean) => {
  const st = {};
  (styles || []).forEach((i) => {
    if (i.key && i.value) {
      // 跟产品协商，做实验不做预拉取，只做在线的
      // if (i.key === 'tag' && i.value.split('|').length === 3) {
      //   st.color = '#136CE9';
      //   st['star-video-tag'] = i.value;
      //   return true;
      // }
      // if (i.key === 'color' && st.color) {
      //   return true;
      // }
      const [key1, key2] = i.key.split('-');
      let key = key1;
      if (key2) {
        const [first = '', ...rest] = key2;
        key = [key1, first.toUpperCase()].concat(rest).join('');
      }
      st[key] = i.value + (highLevel ? '!important' : '');
    }
  });
  return st;
};
export function data2ContentDom(value) {
  if (isArray(value)) {
    const children = [];
    const len = value.length;
    value.forEach((data, index) => {
      const kIndex = `contentKey_${index}`;
      const st = getStyleByArrayData(data.ext);
      if (len <= 1) {
        st.display = 'block';
      }
      children.push(
        st['star-video-tag'] ? (
          <span style={st} key={kIndex} onClick={() => {}}>
            {data.txt}
            {st['star-video-tag'] && <i className="star--tag-icon" />}
          </span>
        ) : (
          <span style={st} key={kIndex}>
            {data.txt}
          </span>
        ),
      );
    });
    return children;
  }
  return <span>{value}</span>;
}

export const getImageExtData = (imgExternalData: Object) => {
  let isQb = false;
  if (typeof window !== 'undefined' && window.navigator?.userAgent) {
    isQb = isQbInfoApp(window.navigator.userAgent);
  }
  if (!isQb) {
    return {};
  }
  const version = get(window, 'browser.env.version');
  if (version < 90) {
    return {};
  }
  if (imgExternalData) {
    if (imgExternalData['1']) {
      // 智能识图约定key
      const extDataStr = imgExternalData['1'];
      try {
        const { sText = '', sBuParam = '' } = JSON.parse(extDataStr) || {};
        return { sText, sBuParam };
      } catch (e) {
        console.log(e);
      }
    }
  }
  return {};
};
